import { useTranslation } from "react-i18next";

import TableCategory, {
  getTableCategoryFilters,
} from "@/components/Tree/TableCategory";
import ListTable from "@/modules/list-table";
import { ModelLink } from "@/modules/model-link";
import { TABLE_FILTER_TEXT } from "@/modules/table-filter";

const FavoritesTable = (listTableProps) => {
  const { t } = useTranslation();

  const defaultColumns = [
    {
      title: t("global:category"),
      dataIndex: "type",
      width: 140,
      className: "type",
      render: (type) => <TableCategory type={type} />,
      filterMode: "tree",
      filters: getTableCategoryFilters(t),
    },
    {
      title: t("global:name"),
      dataIndex: "name",
      className: "table-name",
      render: (_name, item) => <ModelLink model={item.type} item={item} />,
      ...TABLE_FILTER_TEXT,
    },
  ];

  return <ListTable columns={defaultColumns} {...listTableProps} />;
};

export default FavoritesTable;
